import html2pdf from "html2pdf.js";

export default function printPDF(div_id, doc_name, orientation = null) {
  const wrapper = document.getElementById(div_id);

  // Apply scaling class if you’re using one
  wrapper.classList.add("scaled");

  // Measure content width and height
  const contentWidth = wrapper.scrollWidth;
  const contentHeight = wrapper.scrollHeight;

  // Calculate aspect ratio
  // const aspectRatio = contentWidth / contentHeight;

  // Decide orientation based on aspect ratio
  // const orientation = aspectRatio > 1.1 ? "landscape" : "portrait";
  // const orientation = aspectRatio > 1.1 ? "portrait" : "portrait";

  if (!orientation) {
    const aspectRatio = contentWidth / contentHeight;
    orientation = aspectRatio > 1.1 ? "landscape" : "portrait";
  }

  // Hide elements with .exclude-print
  const elementsToHide = wrapper.querySelectorAll(".exclude-print");
  elementsToHide.forEach((el) => {
    el.style.display = "none";
  });

  html2pdf()
    .from(wrapper)
    .set({
      margin: 0.1,
      filename: doc_name + ".pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        windowWidth: contentWidth,
      },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: orientation,
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    })
    .toPdf()
    .get("pdf")
    .then((pdf) => {
      // const blobUrl = pdf.output("bloburl");
      // window.open(blobUrl);
      pdf.save(doc_name + ".pdf");

      // Restore hidden elements
      elementsToHide.forEach((el) => {
        el.style.display = "";
      });

      // Clean up
      wrapper.classList.remove("scaled");
    });

  // html2pdf()
  //   .from(wrapper)
  //   .set({
  //     margin: 0.1,
  //     filename: `${doc_name}.pdf`,
  //     image: { type: "jpeg", quality: 0.98 },
  //     html2canvas: { scale: 2, useCORS: true, windowWidth: contentWidth },
  //     jsPDF: { unit: "in", format: "a4", orientation },
  //     pagebreak: { mode: ["avoid-all", "css", "legacy"] },
  //   })
  //   .toPdf()
  //   .get("pdf")
  //   .then((pdf) => {
  //     const blob = pdf.output("blob");
  //     const blobUrl = URL.createObjectURL(blob);

  //     // ✅ Create download link with filename
  //     const link = document.createElement("a");
  //     link.href = blobUrl;
  //     link.download = `${doc_name}.pdf`; // applies correct filename
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);

  //     // ✅ Then open in new tab too
  //     window.open(blobUrl);

  //     // cleanup hidden elements
  //     elementsToHide.forEach((el) => (el.style.display = ""));
  //     wrapper.classList.remove("scaled");
  //   });
}

// export default function printPDF(div_id, doc_name) {
//   const element = document.getElementById(div_id);

//   html2pdf()
//     .from(element)
//     .set({
//       margin: 0.5,
//       filename: doc_name + ".pdf",
//       image: { type: "jpeg", quality: 0.98 },
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
//       pagebreak: { avoid: ".avoid-break" },
//     })
//     .toPdf()
//     .get("pdf")
//     .then((pdf) => {
//       const blobUrl = pdf.output("bloburl");
//       const printWindow = window.open(blobUrl);
//       // Optionally auto trigger print on window load
//       printWindow.onload = () => {
//         printWindow.print();
//       };
//     });
// }

// export default function downloadPDF(div_id, doc_name) {
//   const element = document.getElementById(div_id);
//   html2pdf()
//     .from(element)
//     .set({
//       margin: 0.5,
//       filename: doc_name + ".pdf",
//       image: { type: "jpeg", quality: 0.98 },
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
//       pagebreak: { avoid: ".avoid-break" },
//     })
//     .save();
// }
